import React from 'react'

function Icon({iconColor, iconName, className}) {
  return (
    <span class={`icon icon-${iconName} ${ className ? className : '' } ${ iconColor ? iconColor : '' }`} data-colored={ iconColor ? 'true' : 'false' } ></span>
  )
}

export default Icon
